import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import PassThrough from '@/layouts/PassThrough'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: MainLayout,
      name: 'dashboard',
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: '/dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/dashboard/main'),
        },
        {
          path: '/orders',
          name: 'orders.index',
          meta: {
            title: 'Sales Orders',
          },
          component: () => import('./views/sales-orders'),
          children: [
            {
              path: '/orders/view/:id?',
              name: 'order.view',
              meta: {
                title: 'Sales Order',
              },
              component: () => import('./views/sales-orders/detail'),
            },
          ],
        },
        {
          path: '/resellers',
          name: 'reseller.index',
          meta: {
            title: 'Resellers',
          },
          component: () => import('./views/reseller'),
          children: [
            {
              path: '/resellers/detail/:seller_hashid',
              name: 'profile.detail',
              component: () => import('./views/reseller/detail'),
            },
          ],
        },
        {
          path: '/discounts',
          name: 'discount.vouchers',
          meta: {
            title: 'Vouchers',
          },
          component: () => import('@/views/discounts/voucher'),
          children: [
            {
              path: '/discounts/view/:id',
              name: 'discounts.view',
              meta: {
                title: 'Voucher Detail',
              },
              component: () => import('@/views/discounts/voucher/detail'),
            },
          ],
        },
        // {
        //   path: '/discounts/view/:id',
        //   name: 'discounts.view',
        //   meta: {
        //     title: 'Voucher Detail',
        //   },
        //   component: () => import('@/views/discounts/voucher/detail'),
        // },
        {
          path: '/discounts/add-voucher',
          meta: {
            title: 'Add Voucher',
          },
          component: () => import('./views/discounts/voucher/create'),
        },
        {
          path: '/discounts/edit-voucher/:id',
          name: 'edit.voucher',
          meta: {
            title: 'Edit Voucher',
          },
          component: () => import('./views/discounts/voucher/edit'),
        },
        {
          path: 'catalogue',
          component: PassThrough,
          name: 'catalogue',
          redirect: '/catalogue/products',
          children: [
            {
              path: 'products',
              name: 'catalogue.product.index',
              component: () => import('./views/catalogue/products/index'),
            },
            {
              path: 'product/add',
              name: 'catalogue.product.create',
              component: () => import('./views/catalogue/products/Create'),
            },
            {
              path: 'product/:id/edit',
              name: 'catalogue.product.edit',
              component: () => import('./views/catalogue/products/Edit'),
            },
          ],
        },

        {
          path: 'settings',
          redirect: '/settings/store',
          component: PassThrough,
          children: [
            {
              path: 'store/:type?',
              component: () => import('./views/settings/store/index.vue'),
            },
          ],
        },

        {
          path: 'profile',
          component: PassThrough,
          children: [
            {
              path: 'change-password',
              component: () => import('./views/Profile/ChangePassword.vue'),
            },
          ],
        },

      ],
    },

    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/reset-password/:hasId/:token',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/reset-password'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (!store.state.app.id && to.path !== '/auth/404' && !store.state.app.fetched) {
    return next('/auth/404')
  }

  if (to.matched.some(record => record.meta && record.meta.authRequired)) {
    const exp = store.getters['user/expireIn']

    if (exp < (new Date().getTime() / 1000)) {
      store.commit('user/LOGOUT')
    }

    if (!store.getters['user/authorized']) {
      return next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      })
    }
  }

  next()
})

export default router
